<template>
  <div>
    <div class="col-grow flex justify-between h-full">
      <e-window-table
          class="col-grow h-full h-limited"
          :columns="['ID', 'Título', 'Tipo', 'Comitente', 'Opções']"
      >
        <e-tr v-for="(data, index) in bens" :key="index">
          <e-td><span>{{ String(data.id).padStart(4, '0') }}</span></e-td>
          <e-td>{{ data.descricao }}</e-td>
          <e-td>{{ data.tipo.nome }}</e-td>
          <e-td>{{ data.comitente.pessoa.name }}</e-td>
          <e-td>
            <a @click="windowBem(data.id)"><i class="erp-icon search min"></i> </a>
            <u-icon name="times" type="fa" icon-style="regular" class="text-negative text-md m-l cursor-pointer m-b-xs" @click.native="remove(data)"></u-icon>
          </e-td>
        </e-tr>
        <e-tr v-if="!bens || !bens.length">
          <e-td style="text-align: left !important;" colspan="100%">
            Nenhum registro
          </e-td>
        </e-tr>
      </e-window-table>
    </div>
  </div>
</template>

<script>
import {
  EWindowTable,
  ETd,
  ETr
} from 'uloc-vue-plugin-erp'
import windowBem from '../../../../../bem/windows/bem'

export default {
  name: "TableBens",
  props: {
    bens: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  components: {
    EWindowTable,
    ETd,
    ETr
  },
  methods: {
    remove (data) {
      console.log(data)
      this.$emit('remove', data)
    },
    windowBem
  }
}
</script>

<style scoped>

</style>